<div class="remote-video">
  <ng-container [ngTemplateOutlet]="displayTemplate"></ng-container>
  <ng-template #localvideo>
    <app-localvideo></app-localvideo>
  </ng-template>
  <ng-template #remotevideo>
    <app-remotevideo></app-remotevideo>
  </ng-template>
</div>

<div class="call-wrapper text-center">
  <div class="audio_call">
    <h3 class="my-2 text-white">
      {{
        apiservice.remote_video
          ? apiservice.remote_view_data.uname
          : apiservice.session_details.user_name
      }}
    </h3>
    <div class="audio_icon my-2">
      <em
        class="bi btn-icon"
        [ngClass]="
          apiservice.session_details.audio_status
            ? 'bi-mic-fill'
            : 'bi-mic-mute-fill'
        "
      ></em>
    </div>

    <div class="audio_mic my-2">
      <!-- Audio Visualizer -->
      <div
        class="audio_visualizer"
        *ngIf="apiservice.session_details.audio_status"
      >
        <img src="assets/images/audio_visualizer.svg" alt="Audio visualizer" />
      </div>
      <!-- END Audio Visualizer -->
    </div>
  </div>
</div>
